import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";
import { AdminUser } from "@/models/admin-user";
import {SharedFilesResponse} from "@/models/sharedFiles";

class AdminService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt
      }
    });
  }

  async getIntegrationNumber(): Promise<AxiosResponse<number>> {
    return await this.client.get("/admin_get_integration_number");
  }

  async updateIntegrationNumber(formData: any): Promise<AxiosResponse<number>> {
    return await this.client.put("/admin_update_integration_number", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
  async getUsers(): Promise<AxiosResponse<AdminUser[]>> {
    return await this.client.get("/admin_get_users");
  }
  async resetPasswordUsers(formData:any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_reset_password_users", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
  async deleteUsers(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_delete_users", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
  async updateUsers(formData): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_update_users", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
  async createUsers(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.post("/admin_create_users", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
  async getClockifyReport(): Promise<AxiosResponse<string>> {
    return await this.client.get("/admin_get_clockify_report");
  }

  async updateClockifyReport(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_update_clockify_report", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async deleteAgreements(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_delete_agreement", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async uploadAgreements(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.post("/admin_create_agreement", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  async uploadIntegrationSummary(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_update_integration_summary", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  async deleteIntegrationSummary(): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_delete_integration_summary");
  }

  async getIntegrationSummary(): Promise<AxiosResponse<SharedFilesResponse>> {
    return await this.client.get("/admin_get_integration_summary");
  }

  async getProjectConfig(): Promise<AxiosResponse<any>> {
    return await this.client.get("/admin_get_project_config");
  }

  async updateProjectConfig(formData: any): Promise<AxiosResponse<any>> {
    return await this.client.put("/admin_update_project_config", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async createTeams(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.post("/admin_create_team", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  async updateTeams(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_update_team", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  async deleteTeams(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/admin_delete_team", formData,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
}

export default AdminService;
